module.exports = __webpack_public_path__ + "static/diary-b75637745dfc64b018fca0eedbe3e310.jpg";